import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { AddClosedExceptionData } from '../../closed-exceptions/models/closed-exceptions.model';
import { AddScheduleHourData } from '../../schedule-hours/models/schedule-hours.model';
import { ScheduleDetailSaveEvent } from '../models/schedule-detail-form-submit-event';
import { GetScheduleDetail_schedule } from '../queries/generated/GetScheduleDetail';
import { SaveSchedule } from '../queries/generated/SaveSchedule';

export const scheduleDetailLoad = createAction('[Schedule Detail] Load');

export const scheduleDetailCancel = createAction('[Schedule Detail] Cancel');

export const scheduleDetailAccessDenied = createAction('[Schedule Detail] Access Denied');

export const loadScheduleDetailSuccess = createAction(
   '[API] Load Schedule Success',
   props<{ data: GetScheduleDetail_schedule }>()
);

export const updateScheduleId = createAction('[Schedule Detail] Update Schedule Id', props<{ scheduleId: number }>());

export const deleteSchedule = createAction(
   '[Schedule Detail] Delete Schedule',
   props<{ scheduleId: number; scheduleDetailId: number; name: string | null }>()
);

export const deleteScheduleSuccess = createAction(
   '[Schedule Detail] Delete Schedule Success',
   props<{ scheduleId: number; name: string | null }>()
);

export const deleteScheduleFailure = createAction(
   '[Schedule Detail] Delete Schedule Failure',
   props<SingleGraphError>()
);

export const deleteScheduleDetailFailure = createAction(
   '[Schedule Detail] Delete Schedule Details Failure',
   props<SingleGraphError>()
);

export const loadScheduleDetailFailure = createAction('[API] Load Schedule Failure', props<SingleGraphError>());

export const saveScheduleDetail = createAction('[Schedule Detail] Save', props<ScheduleDetailSaveEvent>());

export const saveScheduleDetailSuccess = createAction(
   '[Schedule Detail] Save Success',
   props<{ data: SaveSchedule }>()
);

export const saveScheduleDetailFailure = createAction('[Schedule Detail] Save Failure', props<SingleGraphError>());

export const addScheduleHour = createAction('[Schedule Detail] Add Schedule Hour');

export const scheduleHourItemDialogSubmit = createAction(
   '[Schedule Hour Dialog] Submit',
   props<{ scheduleHourItem: AddScheduleHourData }>()
);

export const addClosedException = createAction(
   '[Schedule Detail] Add Closed Exception',
   props<{ scheduleId: number }>()
);

export const closedExceptionItemDialogSubmit = createAction(
   '[Closed Exception Dialog] Submit',
   props<{ closedExceptionItem: AddClosedExceptionData }>()
);

export const loadPageNoSchedule = createAction('[Schedule Detail] Load Page No Schedule');
